import Vue from "vue";
import App from "./App.vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import router from "./router";
import site from "./config/config.js";
import ElementUI from "element-ui";
import store from "@/store";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/index.css";
import requests from "./utils/request.js";
import Vant from "vant";
import "vant/lib/index.css";
// 在 main.js 中引入
import "./assets/css/font.css";
import http from "./api/index";
Vue.use(Vuex);

Vue.prototype.$store = store;
Vue.prototype.$http = http;
Vue.prototype.rq = requests;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(site);
Vue.use(Vant);


new Vue({
  router,
  store: store,
  render: (h) => h(App),
}).$mount("#app");
